(function() {
    'use strict';
    /**
     @namespace Odigeo.UIElements Holds all the logic related to UI elements enhancement
     */
    Odigeo.UIElements = {};

    _.extend(Odigeo.UIElements, /** @lends Odigeo.UIElements */ {
        enhanceView: function(jqObj) {
            var saveEnhancement = function(enhancement) {
                var skip = false;
                _.each(Odigeo.UIElements.enhanced, function(elem, index, enhancementList) {
                    if (enhancementList[index] === this) {
                        skip = true;
                    }
                });
                if (!skip && $(this).attr('data-skip-enhance') !== 'true') {
                    Odigeo.UIElements.enhanced.push(this);
                    Odigeo.UIElements[enhancement.enhanceMethod](this);
                }
            };

            if (!(jqObj instanceof $)) {
                jqObj = $(jqObj);
                if (!(jqObj instanceof $)) {
                    return;
                }
            } else if (jqObj.length === 0) {
                return;
            }

            _.each(Odigeo.UIElements.enhancementList, function(enhancement, index, enhancementList) {
                if (jqObj.not('[data-skip-enhance=true]').is(enhancement.selector)) {
                    jqObj.each(function() {
                        _.bind(saveEnhancement, this)(enhancement, enhancementList);
                    });
                } else {
                    jqObj.find(enhancement.selector).not('[data-skip-enhance=true]').each(function() {
                        _.bind(saveEnhancement, this)(enhancement, enhancementList);
                    });
                }
            });
        },
        /**
         A list of all the enhancements that would be done of every jQuery object given
         @type Object
         @private
         */
        enhancementList: {
            scrollable: {
                selector: '[data-scrollable=true]',
                enhanceMethod: 'enhanceScrollable',
            },
        },
        /**
         A list of objects already enhanced (used to-mobile skip them while iterating through DOM)
         @type Array
         @private
         */
        enhanced: [],
    });
}());
